(function () {

    let app = angular.module('TetherApp');

    let ApiUserController = function (
        $window,
        $mdDialog
    ) {


        let DialogController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.parent = self;
            dCtrl.message = undefined;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };

            dCtrl.answer = function (answer) {
                $mdDialog.hide(answer);
            };

            let onSend = function (data) {
                // console.log('success');
            };

            let onError = function (data) {
                // console.log('error');
            };

        };

        this.apiUserSelector = function (ev) {
            DialogController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: DialogController,
                controllerAs: 'apiUserSelectorController',
                bindToController: true,
                templateUrl: '/api-user/api-user-pop-up',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true
            });

        };

    };



    angular.module('TetherApp').controller(
        'ApiUserController',
        [
            '$window',
            '$mdDialog',
            ApiUserController
        ]
    );


}());
